var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled, { css } from "styled-components";
import { getColor } from "../../theme";
import alignSelf from "../../mixins/alignSelf";
import margin from "../../mixins/margin";
import padding from "../../mixins/padding";
import textTransform from "../../mixins/textTransform";
import textAlign from "./mixins/textAlign";
import textDecoration from "./mixins/textDecoration";
import truncate from "./mixins/truncate";
import whiteSpace from "./mixins/whiteSpace";
import wordBreak from "./mixins/wordBreak";
import opacity from "../../mixins/opacity";
var makeFontSize = function (size) { return function () { return "font-size: ".concat(size, ";"); }; };
var makeLineHeight = function (size) { return function () { return "line-height: ".concat(size, ";"); }; };
var makeFontWeight = function (defaultStrong) { return function (_a) {
    var _b = _a.strong, strong = _b === void 0 ? defaultStrong : _b;
    return "font-weight: ".concat(strong ? "bold" : "normal", ";");
}; };
var fontColor = function (_a) {
    var theme = _a.theme, _b = _a.color, color = _b === void 0 ? "text" : _b;
    return "color: ".concat(getColor(color)({ theme: theme }), ";");
};
var typography = css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "  \n  ", "\n  ", "\n  ", "\n"], ["\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "  \n  ", "\n  ", "\n  ", "\n"])), fontColor, alignSelf, textAlign, textDecoration, textTransform, truncate, whiteSpace, wordBreak, margin, padding, opacity);
export var makeTypography = function (Component, _a) {
    var fontSize = _a.fontSize, lineHeight = _a.lineHeight, strong = _a.strong;
    return styled(Component)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  font-family: \"IBM Plex Sans\", sans-serif;\n  font-style: normal;\n  ", "\n  ", "\n  ", "\n  ", "\n"], ["\n  font-family: \"IBM Plex Sans\", sans-serif;\n  font-style: normal;\n  ", "\n  ", "\n  ", "\n  ", "\n"])), makeFontSize(fontSize), makeLineHeight(lineHeight), makeFontWeight(strong), typography);
};
export var makeH0 = function (Component) {
    return makeTypography(Component, {
        fontSize: "26px",
        lineHeight: "32px",
        strong: true,
    });
};
export var makeH1 = function (Component) {
    return makeTypography(Component, {
        fontSize: "24px",
        lineHeight: "28px",
        strong: true,
    });
};
export var makeH2 = function (Component) {
    return makeTypography(Component, {
        fontSize: "22px",
        lineHeight: "24px",
        strong: true,
    });
};
export var makeH3 = function (Component) {
    return makeTypography(Component, {
        fontSize: "20px",
        lineHeight: "24px",
        strong: true,
    });
};
export var makeH4 = function (Component) {
    return makeTypography(Component, {
        fontSize: "16px",
        lineHeight: "21px",
        strong: true,
    });
};
export var makeH5 = function (Component) {
    return makeTypography(Component, {
        fontSize: "14px",
        lineHeight: "18px",
        strong: true,
    });
};
export var makeH6 = function (Component) {
    return makeTypography(Component, {
        fontSize: "12px",
        lineHeight: "14px",
        strong: true,
    });
};
// Text
export var makeFemto = function (Component) {
    return makeTypography(Component, {
        fontSize: "8px",
        lineHeight: "10px",
    });
};
export var makeNano = function (Component) {
    return makeTypography(Component, {
        fontSize: "10px",
        lineHeight: "13px",
    });
};
export var makeMicro = function (Component) {
    return makeTypography(Component, {
        fontSize: "11px",
        lineHeight: "14px",
    });
};
export var makeSmall = function (Component) {
    return makeTypography(Component, {
        fontSize: "12px",
        lineHeight: "16px",
    });
};
export var makeText = function (Component) {
    return makeTypography(Component, {
        fontSize: "14px",
        lineHeight: "20px",
    });
};
export var makeBig = function (Component) {
    return makeTypography(Component, {
        fontSize: "16px",
        lineHeight: "18px",
    });
};
export var makeBigger = function (Component) {
    return makeTypography(Component, {
        fontSize: "24px",
        lineHeight: "32px",
    });
};
export var makeHuge = function (Component) {
    return makeTypography(Component, {
        fontSize: "36px",
        lineHeight: "44px",
    });
};
var templateObject_1, templateObject_2;
